<template>
    <div class="list_item" @click="goDetailPage">
        <!-- Address  start -->
        <div class="item_cell cell">
            <div class="address">
                <a :href="cellData.link" rel="noopener noreferrer">{{
                    !isShowMask ? $ft.formatAddr(cellData.address) : $t('addressNotDisclosed')
                }}</a>
            </div>
        </div>
        <!-- Address end -->
        <!-- Sold Date start -->
        <div class="item_cell cell">
            <only-client>
                <span class="text_common">{{
                    $ft.formatDate(new Date(cellData.listDate), 'MM/dd/yyyy')
                }}</span>
            </only-client>
        </div>
        <!-- Sold Date end -->
        <!-- Sold PRICE start -->
        <div class="item_cell cell">
            <div class="sold_price t_right" v-if="!isShowMask">
                <template v-if="showPrice">
                    <div class="price">
                        {{
                            $ft.formatUnitNum(
                                cellData.showPrice,
                                false,
                                0,
                                currencySymbol
                            )
                        }}
                    </div>
                    <div
                        class="tendency"
                        :class="{
                            up: cellData.status > 0,
                            down: cellData.status < 0
                        }"
                    >
                        <div v-if="cellData.status !== 0">
                            <span
                                class="iconfont"
                                :class="{
                                    'icon-trend-up': cellData.status > 0,
                                    'icon-trend-down': cellData.status < 0
                                }"
                            ></span>
                            <span>{{ changePriceNum }}</span>
                        </div>
                    </div>
                </template>
                <div v-else class="empty-price">--</div>
            </div>
            <PriceMask class="sold_price t_right" v-else />
        </div>
        <!-- Sold PRICE end -->
    </div>
</template>

<script>
import common from '../../../_mixins/table-item/common';
export default {
    name: 'table-item',
    mixins: [common]
};
</script>

<style lang="scss">
.list-table-mb.standard{
    .list_item {
        cursor: pointer;
    }
    /* item_cell  The style settings under  start */
    .item_cell {
        font-size: 12px;
        &.cell {
            display: table-cell;
        }
        padding: 14px 0;
        border-bottom: 1px solid var(--color-border);
        height: 100%;
        vertical-align: middle;
        .t_right {
            text-align: right;
        }
        .address {
            padding-right: 30px;
            word-break: break-word;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            font-size: 12px;
            line-height: 1.5;
            color: var(--color-label);
        }
        .text_common {
            color: var(--color-info);
        }
        .sold_price {
            white-space: nowrap;
            .price {
                font-size: 16px;
                font-weight: bold;
                line-height: 1.25;
                color: var(--color-text);
                margin-bottom: 6px;
            }
            .tendency {
                font-weight: bold;
                .iconfont {
                    font-size: 8px;
                }
                &.up {
                    color: #96efb4;
                }
                &.down {
                    color: #ffb8b4;
                }
            }
            .empty-price {
                font-size: 16px;
            }
        }
    }
    /* item_cell  The style settings under  end */
}
</style>
